import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const ServiceHero = ({ title, description, imageSrc, lightCircleColor, darkCircleColor }) => {
  return (
    <div className="relative w-full min-h-screen flex items-center justify-center px-8 py-16 bg-[#f5f3eb] dark:bg-[#1c1c1c] overflow-hidden">
      <header className="flex flex-col lg:flex-row items-center lg:justify-between w-full max-w-7xl mx-auto relative">
        
        {/* Left Side - Fading in Text Content */}
        <motion.div
          className="max-w-2xl lg:w-1/2"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          style={{
            marginTop: "5vh", // Moves text & buttons slightly up to match Maintenance
          }}
        >
          <h1 className="text-[35px] md:text-[45px] lg:text-[55px] leading-[40px] md:leading-[50px] lg:leading-[60px] text-left text-[#4b534e] dark:text-white">
            {title}
          </h1>
          <p className="text-[16px] md:text-[18px] mt-4 text-left text-[#7fc7e6] dark:text-gray-400">
            {description}
          </p>

          <div className="flex items-center flex-wrap lg:justify-start justify-center gap-5 mt-8">
            {/* Updated Buttons with Links */}
            <Link to="/faq">
              <button className="px-6 py-2 bg-[#4b534e] text-white dark:bg-[#e5471f] rounded-md shadow-md hover:opacity-80 transition">
                Find Out More
              </button>
            </Link>
            <Link to="/contact">
              <button className="px-6 py-2 border border-[#4b534e] text-[#4b534e] dark:text-white dark:border-[#e5471f] rounded-md shadow-md hover:bg-[#4b534e] hover:text-white dark:hover:bg-[#e5471f] transition">
                Contact
              </button>
            </Link>
          </div>
        </motion.div>

        {/* Right Side - Image with Adjusted Circle Size */}
        <div className="relative lg:w-1/2 flex justify-center lg:justify-end mt-10 lg:mt-0">
          
          {/* 🔴 Circle - Slightly Lower on Mobile to Match Maintenance */}
          <div
            className="absolute rounded-full"
            style={{
              width: "80vw", // Responsive size
              height: "80vw",
              maxWidth: "500px", // Adjusted for desktop
              maxHeight: "500px",
              backgroundColor: `var(--circle-color)`,
              opacity: 0.25,
              zIndex: 1, 
              top: "55%", // Moves the circle slightly higher to prevent button overlap
              left: "50%",
              transform: "translate(-50%, -50%)",
              pointerEvents: "none",
            }}
          ></div>

          {/* 🔵 Floating Image - Aligned with Maintenance Page */}
          <motion.img
            src={imageSrc}
            alt={title}
            className="relative z-10 w-[70vw] md:w-[550px] lg:w-[850px]"
            style={{
              maxWidth: "750px",
              maxHeight: "auto",
              marginTop: "3vh", // Moves image slightly down
            }}
            animate={{ y: [0, -5, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>
      </header>

      {/* CSS Variables for Dynamic Circle Color */}
      <style jsx>{`
        :root {
          --circle-color: ${lightCircleColor};
        }
        .dark {
          --circle-color: ${darkCircleColor};
        }
      `}</style>
    </div>
  );
};

export default ServiceHero;


